export default __webpack_public_path__ + "static/benefit-cards-c243337149d00ef81c0b5e49045b2616.png";